<template>
    <div class="landing-page-container" :style="containerBgStyle">
        <div class="custom-product" v-for="item in visibleModules"
            :key="item.id">
            <img :src="item.imageUrl" class="product-img"
                v-if="item.imageUrl"
                @click="jumpUrl(item.linkUrl)"
                :class="{ 'active': item.moduleType === 4 || item.moduleType === 5 || item.moduleType === 6 }">
            <div class="product-info"
                v-if="(item.moduleType === 4 || item.moduleType === 5 || item.moduleType === 6) && !item.hide">
                <div class="product-content">
                    <div class="product-list"
                        v-for="product in item.items"
                        :key="product.id"
                        @click="handleProductClick(product)">
                        <img :src="product.listImagePath && product.listImagePath.cdnFilePathPc"
                            alt="">
                        <div class="product-desc">
                            <p>{{ product.productName }}</p>
                            <div class="price">
                                <span
                                    class="rmb">¥</span><b
                                    class="amount">{{ product.realDiscountStatus ? product.realDiscountPrice : product.lowestPrice.split(',')[0] }}</b>
                                <span
                                    v-if="product.realDiscountStatus">到手价</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="not-data" v-if="loading && modules.length === 0">
            <img src="@/assets/images/not-happy.png" alt="">
            <p>活动已失效 ~</p>
            <div class="button" @click="jumpHome">返回商城首页</div>
        </div>
    </div>
</template>

<script>
import { customActivityRender } from '@/services/http'
export default {
    name: 'LandingPage',
    data() {
        return {
            modules: [], //活动图列表 模块类型 1头图 2活动信息 3活动信息1 4推荐商品 5自定义商品列表 6自定义商品列表1 7跳转按钮
            bgColorList: [],
            loading: false,
        }
    },
    created() {
        this.getCustomActivityRender()
    },
    computed: {
        visibleModules() {
            return this.modules.filter(item => !(item.moduleType === 4 && !(item.items && item.items.length)))
        },
        containerBgStyle() {
            if (this.bgColorList.length === 0) {
                return {}
            }
            if (this.bgColorList.length === 1) {
                return {
                    background: this.bgColorList[0]
                }
            } else {
                return {
                    background: `linear-gradient(to bottom, ${this.bgColorList.join(', ')})`,
                }
            }
        },
    },
    methods: {
        async getCustomActivityRender() {
            const res = await customActivityRender({
                companyId: 1,
                activityId: this.$route.query.activityId,  //活动Id从url中获取
                platform: 3   //1移动H5 2小程序 3PC
            })
            this.modules = res.data.data.modules
            this.bgColorList = res.data.data.page ? res.data.data.page.bgColorList : []
            this.loading = true
        },
        // 活动商品跳转
        handleProductClick(product) {
            this.$router.push(`/details?id=${product.id}`)
        },
        // 图片跳转
        jumpUrl(url) {
            if (!url) {
                return
            }
            window.location.href = url
        },
        jumpHome() {
            this.$router.push('/')
        }
    }
}
</script>

<style scoped lang="scss">
.landing-page-container {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 56px;

    .custom-product {

        .product-img {
            display: block;
            width: 100%;
            cursor: pointer;

            &.active {
                padding-bottom: 16px;
            }
        }

        .product-info {
            margin-bottom: 35px;

            .product-content {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                flex-wrap: wrap;

                .product-list {
                    width: 220px;
                    height: 342px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    margin-right: 25px;
                    cursor: pointer;

                    &:nth-child(5n) {
                        margin-right: 0;
                    }

                    img {
                        width: 220px;
                        height: 220px;
                        display: block;
                        border-top-left-radius: 4px;
                        border-top-right-radius: 4px;
                    }

                    p {
                        font-size: 15px;
                        line-height: 21px;
                        max-height: 42px;
                        width: 196px;
                        // 两行省略（不能与 white-space: nowrap 同时使用）
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        word-break: break-word;
                        margin-bottom: 24px;
                    }

                    .price {
                        .rmb {
                            font-size: 18px;
                            color: #FF0000;
                            font-weight: bold;
                        }

                        .amount {
                            font-size: 18px;
                            color: #FF0000;
                            font-weight: bold;
                            margin-right: 5px;
                        }

                        span {
                            font-size: 14px;
                            color: #FF0000;
                        }
                    }
                }

                .product-desc {
                    padding: 12px;
                }
            }
        }
    }

    .not-data {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        -webkit-transform: translate3d(-50%, -50%, 0);
        text-align: center;

        img {
            display: block;
            width: 80px;
            height: 80px;
            margin: 0 auto 14px;
        }

        p {
            font-size: 20px;
            margin-bottom: 27px;
        }

        .button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 140px;
            height: 32px;
            border-radius: 16px;
            border: 1px solid #999999;
            opacity: 0.8;
            text-align: center;
            line-height: 32px;
            font-size: 14px;
            cursor: pointer;
        }
    }
}
</style>